import { render, staticRenderFns } from "./editBanner.vue?vue&type=template&id=3062c2ba&scoped=true&"
import script from "./editBanner.vue?vue&type=script&lang=js&"
export * from "./editBanner.vue?vue&type=script&lang=js&"
import style0 from "./editBanner.vue?vue&type=style&index=0&id=3062c2ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3062c2ba",
  null
  
)

export default component.exports